import React, { useState, useEffect, memo, Fragment, useMemo } from "react";
import { Row, Col, } from "react-bootstrap";
import Card from "../../../components/Card";
import DashboardService from "../../../services/pbumku/DashboardService";
// import Progress from "../../../components/progress";

//apexcharts
import Chart from "react-apexcharts";

//swiper
import SwiperCore, { Navigation } from "swiper";

// Import Swiper styles
import "swiper/swiper-bundle.min.css";

//Count-up
import CountUp from "react-countup";

// Activate Navigation for swiper
SwiperCore.use([Navigation]);

const ReportHaccp = memo((props) => {
  const [upi, setUpi] = useState(0);
  const [haccp, setHaccp] = useState([]);
  const [loading,  setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const [tahunsHonnest, setTahunsHonnest] = useState([]);
  const [ skv, setSkv] = useState(0);
  // const [sft, setSft] = useState (0)
  const [upn, setUpn] = useState(0);

  const DashService = useMemo(() => new DashboardService(), []);
  const today = new Date();
  // const year = today.getFullYear();
  // const month = today.getMonth(); // 0-11
  
  const tahunBerjalan = today.getFullYear();
// Tahun HACCP
  const [yearHACCP] = useState(today.getFullYear());
  const [jmlHaccp, setJmlHaccp] = useState({ A: 0, B: 0, C: 0, JUMLAH: 0 });
  const [thnAwal, setThnAwal] = useState(`${tahunBerjalan}-01-01`);
  const [thnAkhir, setThnAkhir] = useState(`${tahunBerjalan}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`);
  const [thnIni] = useState(tahunBerjalan);
  const [rekapSKP, setRekapSKP] = useState([]);
  const [totalTerbitSKP, setTotalTerbitSKP] = useState(0);

   const formatDate = (date, isEndOfDay = false) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // 
    const dd = String(date.getDate()).padStart(2, "0");
    const time = isEndOfDay ? "23:59:59" : "00:00:00";
    return `${yyyy}-${mm}-${dd} ${time}`;
  };
  
    const getRekapSKP = async () => {
    const response = await DashService.getSKPPerPropinsi(formatDate(new Date(thnAwal)), formatDate(new Date(thnAkhir), true),);
    setRekapSKP(response.data);
  };

   const getTotalTerbitSKP = async () => {
    try {
      const response = await DashService.getJumlahTotalSKPTerbit(formatDate(new Date(thnAwal)), formatDate(new Date(thnAkhir), true));
      setTotalTerbitSKP(Number(response.data.totalSKPTerbit) || 0);
    } catch (error) {
      console.error("Gagal ambil total SKP terbit:", error);
      setTotalTerbitSKP(0);
    }
  };

  useEffect(() => {
    getUpiCnt()
    getSftCnt()
    getSkvCnt()
    getUpnCnt()
    getRekapSKP()
    getTotalTerbitSKP()
    getJmlHaccp()
    loadAllData()
  }, []);

  useEffect(() => {
    getUpiCnt()
    getSftCnt()
    getSkvCnt()
    getUpnCnt()
  }, [yearHACCP]);
  
  const loadAllData = async () => {
        try {
            setLoading(true);
            setError(null);
            const HaccpPromise = DashService.getHACCPBulan(thnIni);

            const [ HaccpRes] = await Promise.all([

                HaccpPromise
            ]);


            setHaccp(HaccpRes.data);
        } catch (err) {
            console.error(err);
            setError("Gagal memuat data");
        } finally {
            setLoading(false);
        }
            };

  const getVariableColor = () => {
        let prefix =
            getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
        if (prefix) {
            prefix = prefix.trim();
        }
        const color1 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}primary`
        );
        const color2 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}info`
        );
        const color3 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}primary-tint-20`
        );
        const color4 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}warning`
        );
        return {
            primary: color1.trim(),
            info: color2.trim(),
            warning: color4.trim(),
            primary_light: color3.trim(),
        };
    };
    const variableColors = getVariableColor();
    const colors = [variableColors.primary, variableColors.info];

  const getUpiCnt = async () => {
    try {
      const response = await DashService.getUpi(yearHACCP);
      setUpi(response.data.nilai1);
    } catch (error) {
      console.log(error);
    }
  };

  const getSftCnt = async () => {
  try {
    const response = await DashService.getSft(yearHACCP);
    setHaccp(response.data.nilai1);
  } catch (error) {
    console.log(error);
  }
};

  
  const getUpnCnt = async () => {
    try {
      const response = await DashService.getUpn(yearHACCP);
      setUpn(response.data.nilai1);
    } catch (error) {
      console.log(error);
    }
  };
    const getSkvCnt = async () => {
    try {
      const response = await DashService.getSkv();
      setSkv(response.data[0].nilai1);
    } catch (error) {
      console.log(error);
    }
  };
    const getJmlHaccp = async () => {
  try {
    const tglAwalFormatted = formatDate(new Date(thnAwal));
    const tglAkhirFormatted = formatDate(new Date(thnAkhir));

    // console.log("Fetching HACCP:", tglAwalFormatted, tglAkhirFormatted);

    const response = await DashService.getJumlahHACCP(tglAwalFormatted, tglAkhirFormatted);

    // console.log("API Response:", response.data);

    const data = response.data?.data || response.data || {};

    setJmlHaccp({
      A: Number(data.A) || 0,
      B: Number(data.B) || 0,
      C: Number(data.C) || 0,
      JUMLAH: Number(data.JUMLAH) || 0,
    });
  } catch (error) {
    console.error("Gagal ambil data HACCP:", error);
    setJmlHaccp({ A: 0, B: 0, C: 0, JUMLAH: 0 });
  }
};

      
     const chartHaccp = useMemo(() => {
        const isValidHaccp = Array.isArray(haccp) && haccp.length > 0;
        if (!isValidHaccp) return null;

        // Buat list bulan
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'];
        const bulanList = ['jan', 'feb', 'mar', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'des'];

        const categories = monthNames.slice(0, 6); // Jan - Jun (data sementara)

        // Helper: ambil data per grade
        const getDataPerGrade = (grade) => {
            const item = haccp.find(row => row.grade === grade);
            if (!item) {
                // Jika grade tidak ada di data, isi 0 semua
                return bulanList.slice(0, 6).map(() => 0);
            }
            return bulanList.slice(0, 6).map(bln => item[bln] ?? 0);
        };

        return {
            options: {
                chart: {
                    stacked: false,
                    toolbar: {
                        show: false,
                    },
                },
                colors: ['#008FFB', '#FF4560', '#00E396', '#FEB019'], // Warna per series
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: "45%",
                        endingShape: "rounded",
                        borderRadius: 5,
                    },
                },
                legend: {
                    show: true,
                    position: 'top',
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ["transparent"],
                },
                xaxis: {
                    categories: categories,
                    labels: {
                        minHeight: 20,
                        maxHeight: 20,
                        style: {
                            colors: "#8A92A6",
                        },
                    },
                },
                yaxis: {
                    title: {
                        text: "",
                    },
                    labels: {
                        minWidth: 19,
                        maxWidth: 19,
                        style: {
                            colors: "#8A92A6",
                        },
                    },
                },
                fill: {
                    opacity: 1,
                    type: "solid",
                    colors: ['#008FFB', '#FF4560', '#00E396', '#FEB019'], // Warna per series
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val.toLocaleString("id-ID");
                        },
                    },
                },
            },
            series: [
                {
                    name: "Grade A",
                    data: getDataPerGrade("A")
                },
                {
                    name: "Grade B",
                    data: getDataPerGrade("B")
                },
                {
                    name: "Grade C",
                    data: getDataPerGrade("C")
                },
            ],
        };
    }, [haccp]);
    
const chartDonutHaccp = useMemo(() => {
  const { A, B, C, JUMLAH } = jmlHaccp || {};

  const isValid = [A, B, C].every(
    (val) => typeof val === "number" && !isNaN(val)
  );

  if (!isValid) return null;

  return {
    options: {
      chart: { type: "donut", height: 250, width: 250, toolbar: { show: false } },
      labels: ["Grade A", "Grade B", "Grade C"],
      dataLabels: {
        enabled: true,
        formatter: function (val, opts) {
          const count = [A, B, C][opts.seriesIndex];
          return `${val.toFixed(2)}%`;
        },
      },
      plotOptions: {
        pie: {
          donut: {
            size: "45%",
            labels: {
              show: true,
              total: {
                show: true,
                label: "JUMLAH",
                fontSize: "16px",
                fontWeight: 600,
                formatter: function () {
                  return `${JUMLAH}`;
                },
              },
            },
          },
        },
      },
      legend: { show: true, position: "bottom" },
      colors: ["#008FFB", "#FF4560", "#00E396"],
    },
    series: [A, B, C],
  };
}, [jmlHaccp]);


  const isDonutDataValid = useMemo(() =>
  chartDonutHaccp &&
  Array.isArray(chartDonutHaccp.series) &&
  chartDonutHaccp.series.length === 3 &&
  chartDonutHaccp.series.every((val) => typeof val === 'number' && !isNaN(val)) &&
  chartDonutHaccp.options !== undefined,
  [jmlHaccp, chartDonutHaccp]);

  

  // useEffect(() => {
  // console.log("chartDonutHaccp series:", chartDonutHaccp?.series);
  // console.log("jmlHaccp:", jmlHaccp);
  // }, [chartDonutHaccp, jmlHaccp]);
  

  const skpChartCategories = rekapSKP.map(item => item.uraian_propinsi);
  const skpChartSeriesData = rekapSKP.map(item => {
  const val = Number(item?.jumlah);
  return isNaN(val) ? 0 : val;
  }); 
    const skpChartSeries = [{
        name: 'Jumlah SKP',
        data: skpChartSeriesData
    }];

    const skpChartOptions = {
        chart: {
            type: 'bar',
            stacked: false,
            toolbar: { show: false },
            fontFamily: '"Inter", sans-serif'

        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: '70%',
                dataLabels: {
                    position: 'bottom'
                },
                columnWidth: "45%",
                endingShape: "rounded",
                borderRadius: 5,
            }
        },
        xaxis: {
            categories: skpChartCategories, 
            labels: {
                rotate: 0, 
                formatter: function (val) {
                    return val;
                }
            },
        },
        dataLabels: {
            enabled: false,
            formatter: function (val) {
                return val;
            },
            offsetX: 0,
            style: {
                fontSize: '12px',
                colors: ['#fff']
            },
            dropShadow: {
                enabled: true,
                top: 1,
                left: 1,
                blur: 1,
                opacity: 0.45
            }
        },
        tooltip: { enabled: true },
        colors: ['#008FFB'],
        grid: {
            show: true,
            xaxis: {
                lines: {
                    show: true
                }
            },
            yaxis: {
                lines: {
                    show: false
                }
            }
        }
    };
    
      const chartSKP = {
        series: skpChartSeries,
        options: skpChartOptions
        
    };



return (
   < Fragment>
   <Row>
     <Col md="6" lg="12">
          <Card className="bg-soft-warning mt-1">
            <Card.Body>
              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <h2 className="mb-2">Statistik Sertifikasi Mutu Pascapanen</h2> 
                    <h3 className="text-primary">Tahun {yearHACCP}</h3>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
      </Col>
   </Row>
    <Row>
      <Col xs="12" md="6">
        <div className="card mb-3">
            <div className="flex-wrap card-header d-flex justify-content-between">
                <div className="header-title ">
                    <h2 className="card-title">Jumlah SKP Per Propinsi</h2>
                </div>
                {/* <div className="header-title ">
                    <h6 className="text-primary mb-0">Tahun {thnIni}</h6>
                </div> */}
            </div>
            <div className="card-body">
                  {rekapSKP.length > 0 && chartSKP?.series?.[0]?.data?.length > 0 ? (
                      <Fragment>
                        <Chart
                          options={chartSKP.options}
                          series={chartSKP.series}
                          type="bar"
                          height={400}
                        />
                        <div className="d-flex flex-wrap gap-2 align-items-center justify-content-center mt-1">
                          <div className="d-flex">
                            <span className="badge bg-success px-2 py-1 fs-7 fw-semibold rounded-start">
                              Total SKP Terbit
                            </span>
                            <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
                              {totalTerbitSKP}
                            </span>
                          </div>
                        </div>
                      </Fragment>
                    ) : (
                      <p>Memuat data chart...</p>
                    )}
            </div>
        </div>
        </Col>
        <Col md="6" lg="6">
          <Card className="bg-soft-primary mt-1">
            <Card.Body>
              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div>
                    <h2 className="mb-2">Statistik Sertifikat HACCP</h2> 
                  </div>
                  <div className="d-flex align-items-center text-dark">
                  </div>
                </div>
                <div className="border rounded">
                  <Row>
                    <Col lg="4" md="4" className="col-lg-3 col-md-6">
                      <Card className="bg-soft-info">
                        <Card.Body>
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="bg-soft-info rounded p-3">
                              <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 22 22" fill="currentColor">
                                <path fillRule="evenodd" d="M9.13478 20.7733V17.7156C9.13478 16.9351 9.77217 16.3023 10.5584 16.3023H13.4326C13.8102 16.3023 14.1723 16.4512 14.4393 16.7163C14.7063 16.9813 14.8563 17.3408 14.8563 17.7156V20.7733C14.8539 21.0978 14.9821 21.4099 15.2124 21.6402C15.4427 21.8705 15.7561 22 16.0829 22H18.0438C18.9596 22.0023 19.8388 21.6428 20.4872 21.0008C21.1356 20.3588 21.5 19.487 21.5 18.5778V9.86686C21.5 9.13246 21.1721 8.43584 20.6046 7.96467L13.934 2.67587C12.7737 1.74856 11.1111 1.7785 9.98539 2.74698L3.46701 7.96467C2.87274 8.42195 2.51755 9.12064 2.5 9.86686V18.5689C2.5 20.4639 4.04738 22 5.95617 22H7.87229C8.55123 22 9.103 21.4562 9.10792 20.7822L9.13478 20.7733Z" clipRule="evenodd" />
                              </svg>
                            </div>
                            <div className="text-end">
                              <h2 className="counter"><CountUp start={upi - 50} end={upi} duration={3} /></h2>
                              UPI Tersertifikasi
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg="4" md="4">
                      <Card className="bg-soft-primary">
                        <Card.Body>
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="bg-soft-primary rounded p-3">
                              <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 22 22" fill="currentColor">
                                <path fillRule="evenodd" d="M9.5 12.5537C12.2546 12.5537 14.4626 10.3171 14.4626 7.52684C14.4626 4.73663 12.2546 2.5 9.5 2.5C6.74543 2.5 4.53737 4.73663 4.53737 7.52684C4.53737 10.3171 6.74543 12.5537 9.5 12.5537ZM9.5 15.0152C5.45422 15.0152 2 15.6621 2 18.2464C2 20.8298 5.4332 21.5 9.5 21.5C13.5448 21.5 17 20.8531 17 18.2687C17 15.6844 13.5668 15.0152 9.5 15.0152ZM19.8979 9.58786H21.101C21.5962 9.58786 22 9.99731 22 10.4995C22 11.0016 21.5962 11.4111 21.101 11.4111H19.8979V12.5884C19.8979 13.0906 19.4952 13.5 18.999 13.5C18.5038 13.5 18.1 13.0906 18.1 12.5884V11.4111H16.899C16.4027 11.4111 16 11.0016 16 10.4995C16 9.99731 16.4027 9.58786 16.899 9.58786H18.1V8.41162C18.1 7.90945 18.5038 7.5 18.999 7.5C19.4952 7.5 19.8979 7.90945 19.8979 8.41162V9.58786Z" clipRule="evenodd" />
                              </svg>
                            </div>
                            <div className="text-end">
                              <h2 className="counter"><CountUp start={upn - 50} end={upn} duration={3} /></h2>
                              UPI Baru
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg="4" md="4">
                      <Card className="bg-soft-danger">
                        <Card.Body>
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="bg-soft-danger rounded p-3">
                              <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 22 22" fill="currentColor">
                                <path d="M8.92574 16.39H14.3119C14.7178 16.39 15.0545 16.05 15.0545 15.64C15.0545 15.23 14.7178 14.9 14.3119 14.9H8.92574C8.5198 14.9 8.18317 15.23 8.18317 15.64C8.18317 16.05 8.5198 16.39 8.92574 16.39ZM12.2723 9.9H8.92574C8.5198 9.9 8.18317 10.24 8.18317 10.65C8.18317 11.06 8.5198 11.39 8.92574 11.39H12.2723C12.6782 11.39 13.0149 11.06 13.0149 10.65C13.0149 10.24 12.6782 9.9 12.2723 9.9ZM19.3381 9.02561C19.5708 9.02292 19.8242 9.02 20.0545 9.02C20.302 9.02 20.5 9.22 20.5 9.47V17.51C20.5 19.99 18.5099 22 16.0545 22H8.17327C5.59901 22 3.5 19.89 3.5 17.29V6.51C3.5 4.03 5.5 2 7.96535 2H13.2525C13.5099 2 13.7079 2.21 13.7079 2.46V5.68C13.7079 7.51 15.203 9.01 17.0149 9.02C17.4381 9.02 17.8112 9.02316 18.1377 9.02593C18.3917 9.02809 18.6175 9.03 18.8168 9.03C18.9578 9.03 19.1405 9.02789 19.3381 9.02561ZM19.6111 7.566C18.7972 7.569 17.8378 7.566 17.1477 7.559C16.0527 7.559 15.1507 6.648 15.1507 5.542V2.906C15.1507 2.475 15.6685 2.261 15.9646 2.572C16.5004 3.13476 17.2368 3.90834 17.9699 4.67837C18.7009 5.44632 19.4286 6.21074 19.9507 6.759C20.2398 7.062 20.0279 7.565 19.6111 7.566Z" />
                              </svg>
                            </div>
                            <div className="text-end">
                              <h2 className="counter"><CountUp start={(upi - upn) - 50} end={(upi - upn)} duration={3} /></h2>
                              UPI Lama
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6" md="10">
                      <div className="card">
                            <div className="flex-wrap card-header d-flex justify-content-between">
                                <div className="header-title">
                                    <h5 className="card-title">Jumlah Grade Sertifikat HACCP Terbit Perbulan</h5>
                                </div>
                                {/* <div className="header-title">
                                    <h6 className="text-primary mb-0">Tahun {thnIni}</h6>
                                </div> */}
                            </div>
                            <div className="card-body">
                                {chartHaccp?.options && chartHaccp?.series ? (
                                    <Chart
                                      options={{
                                        ...chartHaccp.options,
                                        chart: {
                                          ...chartHaccp.options.chart,
                                          type: "bar",
                                        },
                                        plotOptions: {
                                          bar: {
                                            horizontal: false,
                                            columnWidth: "55%",
                                          },
                                        },
                                      }}
                                      series={chartHaccp.series}
                                      type="bar"
                                      height="200"
                                    />
                                  ) : (
                                    <p>Memuat chart HACCP...</p>
                                  )}
                            </div>
                        </div>
                        </Col>
                        <Col md="6">
                            <div className="card h-65">
                                <div className="card-body d-flex flex-column align-items-center justify-content-center text-center p-2">
                                    {/* Judul dan Tahun di atas chart */}
                                    <div className="mb-0">
                                        <h5 className="card-title mb-1">Total HACCP Terbit</h5>
                                        {/* <h6 className="text-primary">Tahun {thnIni}</h6> */}
                                    </div>

                                    {/* Donut Chart */}
                                    <div className="chart-container" style={{ width: 250, height: 250, position: 'relative' }}>
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -120%)',
                                                textAlign: 'center',
                                                pointerEvents: 'none',
                                            }}
                                        >
                                        </div>
                                         {chartDonutHaccp && Array.isArray(chartDonutHaccp.series) ? (
                                            <Chart
                                              key={chartDonutHaccp.series.join('-')}
                                              options={chartDonutHaccp.options}
                                              series={chartDonutHaccp.series}
                                              type="donut"
                                              width={250}
                                              height={250}
                                            />
                                          ) : (
                                            <p>Data belum tersedia atau tidak valid.</p>
                                          )}
                                    </div>
                                </div>
                            </div >
                        </Col >
                  </Row>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

  </Fragment>
  );
});
export default ReportHaccp;